<template>
 <!-- :style="{'min-height': docHt + 'px'}" -->
  <div class="wrapper">
    <div class="container">
      <h3 class="h3">您的所属行业？</h3>
      <section>
        <div class="section types-section">
          <h5>主体类型</h5>
          <div class="types-group">
            <div class="tag-item" 
              :class="{'tag-item-active': index == tagCurrent}" 
              v-for="(item, index) in shopNatureList" 
              :key="index"
              @click="toggleTag(item, index)">
                {{item.propertyName}}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="section industry-section">
          <h5>所属行业</h5>
          <!-- 移动端  v-show="isMobile" -->
          <div class="industry-box" @click="openPicker" v-if="isMobile">
            <span class="industry-txt">{{columnName}}</span>
            <span class="iconfont icon-triangle"></span>
          </div>
          <van-popup v-model="isOpen" position="bottom" class="popup">
            <van-picker class="industry-picker-box"
              title="所属行业"
              show-toolbar
              value-key="constantName"
              :columns="shopCategoryList"
              @confirm="onConfirm"
              @cancel="onCancel"
            />
          </van-popup>
          <!-- pc端 -->
          <el-select v-model="form.shopCategory" placeholder="请选择所属行业" class="industry-select-box" @change="handleSelectChange" v-if="!isMobile">
            <el-option
              v-for="item in shopCategoryList"
              :key="item.constantCode"
              :label="item.constantName"
              :value="item.constantCode">
            </el-option>
          </el-select>
          <div class="industry-list" v-show="isOpenList">
            <van-radio-group v-model="form.shopType">
              <van-radio :name="item.propertyId" checked-color="#47B6C7" v-for="item in shopTypeList" :key="item.id" @click="shopTypeClick(item)">{{item.propertyName}}</van-radio>
            </van-radio-group>
          </div>
        </div>
      </section>
      <section> 
        <div class="section self-support-section" v-if="propertyInfo.isRestaurant == 1">
          <div class="radio-group">
            <van-radio-group v-model="form.isAutarky" direction="horizontal">
              <van-radio :name="1" checked-color="#47B6C7" :icon-size="docWidth > 750 ? '20px' : '1rem'">有自营餐厅</van-radio>
              <van-radio :name="0" checked-color="#47B6C7" :icon-size="docWidth > 750 ? '20px' : '1rem'">没有自营餐厅</van-radio>
            </van-radio-group>
          </div>
        </div>
        <div class="section self-support-section" v-if="propertyInfo.isShopMall == 1">
          <div class="radio-group">
            <van-radio-group v-model="propertyInfo.shopMallRadio" direction="horizontal">
              <van-radio :name="1" checked-color="#47B6C7" :icon-size="docWidth > 750 ? '20px' : '1rem'" @click="shopMallClick(1)">有实体店</van-radio>
              <van-radio :name="0" checked-color="#47B6C7" :icon-size="docWidth > 750 ? '20px' : '1rem'" @click="shopMallClick(0)" >没有实体店</van-radio>
            </van-radio-group>
          </div>
        </div>
      </section>
    </div>
    <div class="footer-bar"></div>
    <div class="footer">
      <div class="submit-btn disabled-btn" v-if="!form.shopNature || !form.shopCategory || shopTypeList.length > 0 && !form.shopType">下一步</div>
      <div class="submit-btn" @click="onSubmit" v-else>下一步</div>
    </div>
    <ContactBtn />
  </div>
</template>

<script>
import { getPropertyList, getConstantCategory, getTypesList, } from '@/api/baseinfo';

export default {
  name: 'industry-info',
  data() {
    return {
      docWidth: document.body.offsetWidth > 0 ? document.body.offsetWidth : document.body.clientWidth,
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      isMobile: false,
      isOpen: false,
      isOpenList: false,
      selfSupport: '1',
      tagCurrent: 0,
      columnName: '请选择所属行业',
      shopNatureList: [],
      shopCategoryList: [],
      shopTypeList: [],
      propertyInfo: {
        isRestaurant: 2,   // 是否可选自营餐厅 0 否 1 是 
        isShopMall: 2,    // 是否可选有无实体 0 否 1 是
        shopMallRadio: 1,  // 可选
      },
      form: {
        isAutarky: 1,   // 是否自营
        shopType: undefined,
        shopCategory: undefined,
        shopNature: undefined,  // CS202206101028 企业  CS202206101029 个体户  CS202206101030 个人
      }
    };
  },
  created() {
    let industryInfo = JSON.parse(sessionStorage.getItem('industryInfo')); 
    let propertyInfo = JSON.parse(sessionStorage.getItem('propertyInfo'));
    if(industryInfo) {
      this.form = {
        isAutarky: industryInfo.isAutarky,
        shopType: industryInfo.shopType,
        shopCategory: industryInfo.shopCategory,
        shopNature: industryInfo.shopNature,
      }
    }
    if(propertyInfo) {
      this.propertyInfo = {
        isRestaurant: propertyInfo.isRestaurant,
        isShopMall: propertyInfo.isShopMall ,
        shopMallRadio: propertyInfo.shopMallRadio
      }
    }
    this.mobileTerminal((data) => {
      this.isMobile = data
    })
    this.getNatureList();
    this.getConstantCategory();
  },
  methods: {
    shopTypeClick(data) {
      this.form.isAutarky = data.isRestaurant == 1 ? 1 : 0;
      this.propertyInfo.isRestaurant = data.isRestaurant;
      this.propertyInfo.isShopMall = data.isShopMall;
    },
    shopMallClick(val) {
      this.propertyInfo.shopMallRadio = val;
    },
    toggleTag(data, index) {
      this.form.shopNature = data.propertyId;
      this.tagCurrent = index;
    },
    openPicker() {
      this.isOpen = true;
    },
    // PC端
    handleSelectChange(val) {
      this.form.shopCategory = val;
      this.getTypesList(val);
      this.isOpenList = true;
    },
    // 移动端
    onConfirm(val, index) {
      this.isOpen = false;
      this.columnName = val.constantName;
      this.form.shopCategory = val.constantCode;
      this.getTypesList(val.constantCode);
      this.isOpenList = true;
    },
    onCancel() {
      this.isOpen = false;
    },
    getNatureList() {
      getPropertyList('CS2022061010').then(res => {
        this.shopNatureList = res.data;
        if(this.form.shopNature) {
          res.data.forEach((item, index) => {
            if(item.propertyId == this.form.shopNature) {
              this.tagCurrent = index;
            }
          })
        } else {
          this.form.shopNature = res.data[0].propertyId;
        }
      })
    },
    getConstantCategory() {
      getConstantCategory('CS2022061727').then(res => {
        if(res.data && res.data.length > 0) {
          res.data.forEach((item, index) => {
            if(item.constantCode == this.form.shopCategory) {
              this.columnName = item.constantName;
              this.isOpenList = true;
              this.getTypesList(item.constantCode);
            }
          })
          this.shopCategoryList = res.data;
        }
      })
    },
    getTypesList(code) {
      this.shopTypeList = [];
      getTypesList(code).then(res => {
        this.shopTypeList = res.data;
      })
    },
    onSubmit() {
      // 需要存密码缓存，审核初始密码需要使用
      sessionStorage.setItem('industryInfo', JSON.stringify(this.form));
      sessionStorage.setItem('propertyInfo', JSON.stringify(this.propertyInfo));
      this.$router.push({
        path: '/baseinfo'
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width:750px){
  .container{
    padding-top: .05rem;
    .h3{
      width: 16.7rem;
      margin: .8rem auto 1.4rem;
      font-size: 1.2rem;
      color: #222222;
    }
  }
  .section{
    width: 16.7rem;
    margin: 0 auto;
    h5{
      margin-bottom: .4rem;
      font-size: .7rem;
      color: #666666;
      font-weight: 400;
    }
    .types-group{
      width: 16.7rem;
      display: flex;
      flex-wrap: wrap;
      .tag-item{
        width: 5.1rem;
        height: 2.2rem;
        background: #fff;
        border-radius: .5rem;
        border: .05rem solid #CFE1EA;
        font-size: .8rem;
        color: #222;
        @include flex();
        margin: 0 .5rem .5rem 0;
        cursor: pointer;
        &:nth-child(3n+3){
          margin-right: 0;
        };
      }
      .tag-item-active{
        background: $base-color;
        border: .05rem solid $base-color;
        color: #fff;
      }
    }
  }
  .types-section{
    margin-bottom: 1.2rem;
  }
  .industry-section{
    margin-bottom: 1.8rem;
    .industry-box{
      width: 15.2rem;
      height: 2.4rem;
      border-radius: .5rem;
      border: .05rem solid #DDDDDD;
      display: flex;
      padding: 0 .7rem;
      @include flex(space-between);
      cursor: pointer;
      .industry-txt{
        display: inline-block;
        font-size: .8rem;
        color: #222;
        text-align: left;
      }
      .icon-triangle{
        font-size: .6rem;
        color: #222;
        text-align: rigt;
      }
    }
    .industry-picker-box{

    }
    .industry-select-box{
      width: 16.65rem;
      height: 2.4rem;
      /deep/ .el-input{
        height: 2.4rem;
      }
      /deep/  .el-input__inner{
        height: 2.4rem;
        border-radius: .5rem;
        border: .05rem solid #DDDDDD;
        font-size: .8rem;
        color: #222;
      }
      /deep/ .el-input__inner::-webkit-input-placeholder {
        font-size: .8rem;
        color: #ccc;
        font-weight: 400;
      }
    }
    .industry-list{
      width: 16.7rem;
      max-height: 15rem;
      overflow: auto;
      background: #F5F5F7;
      border-radius: .4rem;
      margin-top: 1.25rem;
      .van-radio-group{
        .van-radio{
          width: 15.5rem;
          height: 3rem;
          margin: 0 auto;
          border-bottom: .05rem solid #ddd;
          font-size: .8rem;
          color: #222;
          text-align: left;
          @include flex-align();
          &:last-child{
            border:0;
          }
        }
      }
    }
  }
  .self-support-section{
    width: 16.7rem;
    height: 3rem;
    margin-bottom: .65rem;
    .radio-group{
      height: 3rem;
      .van-radio-group{
        height: 3rem;
        .van-radio{
          font-size: .8rem;
          color: #222;
          &:first-child{
            margin-right: 1.8rem;
          }
        }
      }
    }
  }
}
@media screen and (min-width:750px){
  .container{
    padding-top: 1px;
    .h3{
      width: 334px;
      margin: 16px auto 28px;
      font-size: 24px;
      color: #222222;
    }
  }
  .section{
    width: 334px;
    margin: 0 auto;
    h5{
      margin-bottom: 8px;
      font-size: 14px;
      color: #666666;
      font-weight: 400;
    }
    .types-group{
      width: 334px;
      display: flex;
      flex-wrap: wrap;
      .tag-item{
        width: 102px;
        height: 44px;
        background: #fff;
        border-radius: 10px;
        border: 1px solid #CFE1EA;
        font-size: 16px;
        color: #222;
        @include flex();
        margin: 0 10px 10px 0;
        cursor: pointer;
        &:nth-child(3n+3){
          margin-right: 0;
        };
      }
      .tag-item-active{
        background: $base-color;
        border: 1px solid $base-color;
        color: #fff;
      }
    }
  }
  .types-section{
    margin-bottom: 24px;
  }
  .industry-section{
    margin-bottom: 36px;
    .industry-box{
      width: 304px;
      height: 48px;
      border-radius: 10px;
      border: 1px solid #DDDDDD;
      display: flex;
      padding: 0 14px;
      @include flex(space-between);
      cursor: pointer;
      .industry-txt{
        display: inline-block;
        font-size: 16px;
        color: #222;
        text-align: left;
      }
      .icon-triangle{
        font-size: 12px;
        color: #222;
        text-align: rigt;
      }
    }
    .industry-picker-box{

    }
    .industry-select-box{
      width: 333px;
      height: 48px;
      /deep/ .el-input{
        height: 48px;
      }
      /deep/  .el-input__inner{
        height: 48px;
        border-radius: 10px;
        border: 1px solid #DDDDDD;
        font-size: 16px;
        color: #222;
      }
      /deep/ .el-input__inner::-webkit-input-placeholder {
        font-size: 16px;
        color: #ccc;
        font-weight: 400;
      }
    }
    .industry-list{
      width: 334px;
      max-height: 300px;
      overflow: auto;
      background: #F5F5F7;
      border-radius: 8px;
      margin-top: 25px;
      .van-radio-group{
        .van-radio{
          width: 310px;
          height: 60px;
          margin: 0 auto;
          border-bottom: 1px solid #ddd;
          font-size: 16px;
          color: #222;
          text-align: left;
          @include flex-align();
          &:last-child{
            border:0;
          }
        }
      }
    }
  }
  .self-support-section{
    width: 334px;
    height: 60px;
    margin-bottom: 13px;
    .radio-group{
      height: 60px;
      .van-radio-group{
        height: 60px;
        .van-radio{
          font-size: 16px;
          color: #222;
          &:first-child{
            margin-right: 36px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/industry-info.vue